import type { SugerenciaRostro } from "../lib/rostro";

// «¿Es Nombre?» — Clientes por cara v1 (tramo 10, D-C6). La webcam del mostrador reconoció a alguien registrado;
// el sistema SUGIERE y quien atiende decide. «Sí» abre su ficha (si es de esta botica) y cuenta como que entró;
// «No» no hace nada más que no volver a preguntar por un rato. Va arriba del copiloto: es lo primero que se mira.
export function TarjetaRostro({ s, onResponder }: { s: SugerenciaRostro; onResponder: (si: boolean) => void }) {
  const nombre = s.alias ? `${s.nombre} («${s.alias}»)` : s.nombre;
  return (
    <div className="flex flex-col gap-2 rounded-[12px] border border-info/40 bg-info-soft px-3 py-2.5" data-testid="tarjeta-rostro" role="status" aria-live="polite">
      <p className="text-[13.5px] leading-snug text-info-ink">
        <span aria-hidden="true">🙂 </span>¿Es <strong>{nombre}</strong>?
        {s.misma_botica !== 1 && <span className="text-[12px]"> · cliente de {s.botica_cliente}</span>}
      </p>
      <p className="text-[11.5px] text-ink-3">La cámara lo cree (parecido {s.parecido.toFixed(2)}). Confírmalo tú antes de atender.</p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onResponder(true)}
          className="min-h-[40px] flex-1 rounded-[9px] bg-ok px-3 text-[13px] font-semibold text-white hover:opacity-90"
        >
          Sí, es
        </button>
        <button
          type="button"
          onClick={() => onResponder(false)}
          className="min-h-[40px] flex-1 rounded-[9px] border border-line-input bg-card px-3 text-[13px] font-semibold text-ink-emph hover:bg-hover-btn"
        >
          No es
        </button>
      </div>
    </div>
  );
}
